export const shoppingTypes = {
    CREATE_SHOPPING: 'CREATE_SHOPPING',
    GET_SHOPPING: 'GET_SHOPPING',
    CURRENT_SHOPPING: 'CURRENT_SHOPPING',
    UPDATE_SHOPPING: 'UPDATE_SHOPPING',
}